import { useTranslation } from 'react-i18next';
import { FilterInputProps } from '@customer/filters/types';
import { MultiselectFilter } from './MultiselectFilter';
import { useMemo } from 'react';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { PartnerResourceFileType } from '@cas/config/documents';
import { setPartnerResourceFileTypes } from '@customer/store/slices/filtersSlice';

const usePartnerResourceFileTypeOptions = (): DropdownItemProps<PartnerResourceFileType>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    return Object.values(PartnerResourceFileType)
      .map((value: PartnerResourceFileType) => ({
        key: value,
        value,
        stringValue: value,
        label: t(`PartnerResourceFileType.${value}`),
      }))
      .sort(
        (
          a: DropdownItemProps<PartnerResourceFileType>,
          b: DropdownItemProps<PartnerResourceFileType>,
        ) => a.label.localeCompare(b.label),
      );
  }, [t]);
};

export const PartnerResourceFileTypesFilter = ({
  label,
  elementRef,
}: FilterInputProps<HTMLVdsBasicDropdownMultiselectElement>) => {
  const { t } = useTranslation();

  return (
    <MultiselectFilter<PartnerResourceFileType>
      filterName="partnerResourceFileTypes"
      label={label ?? t('FileType')}
      action={setPartnerResourceFileTypes}
      elementRef={elementRef}
      useItemsHook={usePartnerResourceFileTypeOptions}
    />
  );
};

export default PartnerResourceFileTypesFilter;
